<template>
  <router-view />
</template>

<script setup>
// 全局背景与样式由 styles/global.css 控制
</script>

<style>
#app {
  min-height: 100%;
  background-color: #f0f2f5;
}
</style>
